/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\MITSUBISHI.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:17:16 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function MITSUBISHI(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <polygon points="538.72 618.11 365.43 618.11 279.53 768.93 453.32 768.93 538.72 618.11 538.72 618.11 538.72 618.11"/>
            <polygon points="626.77 463.39 540.13 311.07 453.23 463.39 540.13 615.96 626.77 463.39 626.77 463.39 626.77 463.39"/>
            <polygon points="626.68 768.93 800.47 768.93 714.57 618.11 541.28 618.11 626.68 768.93 626.68 768.93 626.68 768.93"/>
        </svg>
    );
}

export default MITSUBISHI;
